import {
  apiRequest,
  RiwayatNikahCreate,
  masterRegion,
  masterGajiwebSatker,
  CoupleList,
} from "../../../../../services/adapters/kepegawaian/riwayatnikahService";

class RiwayatNikahRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      RiwayatNikahCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchCouple = async (query) => {
    return await apiRequest(
      "get",
      CoupleList,
      {
        params: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };
}

export default RiwayatNikahRepository;
